export default "__VITE_ASSET__66b6228b__"